export default {
  backgroundColor: Styles.color.grey.ten,
  textColor: Styles.color.secondary,
  titleColor: Styles.color.black,
};
